<template>
    <div id="cv-div-loading" class="vs-con-loading__container">
        <vue-headful :title="$t('add_cv')" />
        <div v-if="sudentSVs.lenth" class="welcone-text p-5 flex mb-5">
            <span> {{ $t("") }} </span>
            <vs-button
                class="ok-button"
                color="white"
                text-color="rgb(30,30,30)"
            >
                OK
            </vs-button>
        </div>
        <vx-card class="lg:p-5">
            <div
                style="cursor: pointer"
                class="flex back-div mb-5"
                @click="goBack()"
            >
                <feather-icon class="cursor-pointer" icon="ArrowLeftIcon" />
                <span>{{ $t("return_back") }}</span>
            </div>
            <ProfileInfo/>
<!--            <div class="lg:flex mb-10 lg:mb-6">-->
<!--                <div>-->
<!--                    <img :src="user.avatar" style="object-fit: cover" alt="" width="105" height="105" />-->
<!--                </div>-->
<!--                <div class="lg:ml-4">-->
<!--                    <div class="name mb-5 text-lg lg:text-xl">-->
<!--                        {{ userName }}-->
<!--                    </div>-->
<!--                    <div class="mt-4">-->
<!--                        <span class="bold mb-2">{{$t("study_plan")}}</span>-->
<!--                        <multiselect-->
<!--                            v-model="studyPlan"-->
<!--                            :options="study_plans"-->
<!--                            :searchable="false"-->
<!--                            open-direction="top"-->
<!--                            :close-on-select="true"-->
<!--                            label="text"-->
<!--                            :placeholder="$t('study_plan')"-->
<!--                            :show-labels="false"-->
<!--                            @input="setStudyPlan()"-->
<!--                        >-->
<!--                        </multiselect>-->
<!--                        &lt;!&ndash; <v-select class="w-full" label="text" :options="schedules" v-model="selectedSchedule" @input="setSchedule()"></v-select> &ndash;&gt;-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
<!--            <div class="mb-10">-->
<!--                <div class="mb-2 lg:mb-5">-->
<!--                    <span class="subtitle-text">{{-->
<!--                        $t("main_information")-->
<!--                    }}</span>-->
<!--                </div>-->
<!--                <div class="mb-10">-->
<!--                    <div class="vals_list">-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.phone">-->
<!--                            <div class="label font-semibold">{{ $t("phone") }}:</div>-->
<!--                            <div>{{ LocalUserData.phone }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.email">-->
<!--                            <div class="label font-semibold">{{ $t("email") }}:</div>-->
<!--                            <div>{{ LocalUserData.email }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.age">-->
<!--                            <div class="label font-semibold">{{ $t("age") }}:</div>-->
<!--                            <div>{{ LocalUserData.age }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.birth_place">-->
<!--                            <div class="label font-semibold">{{ $t("city") }}:</div>-->
<!--                            <div>{{ LocalUserData.birth_place }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.citizenship">-->
<!--                            <div class="label font-semibold">{{ $t("citizenship") }}:</div>-->
<!--                            <div>{{ LocalUserData.citizenship }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center" v-if="LocalUserData.educations">-->
<!--                            <div class="label font-semibold">{{ $t("edication") }}:</div>-->
<!--                            <div>{{ LocalUserData.educations[0].institute }}</div>-->
<!--                        </div>-->
<!--                        <div class="item lg:flex items-center">-->
<!--                            <div class="label font-semibold">{{ $t("family_status") }}:</div>-->
<!--                            <div>{{ LocalUserData.marital_status }}</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="mb-5 lg:mb-10">
                <vs-row>
                    <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="lg:pr-4 mb-5">
                        <div>
                            <span class="bold mb-2">{{
                                $t("desired_position")
                            }}</span>
                            <vs-input
                                class="w-full"
                                v-model="cvData.desired_position"
                                :placeholder="$t('desired_position')"
                            ></vs-input>
                        </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="lg:pr-4 mb-5">
                        <span class="bold mb-2">{{
                                $t("study_plan")
                            }}</span>
                        <multiselect
                            v-model="studyPlan"
                            :options="study_plans"
                            :searchable="false"
                            open-direction="top"
                            :close-on-select="true"
                            label="text"
                            :placeholder="$t('study_plan')"
                            :show-labels="false"
                            @input="setStudyPlan()"
                        >
                        </multiselect>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="lg:pr-4 mb-5 lg:mb-0">
                        <div>
                            <span class="bold mb-2">{{
                                $t("desired_salary")
                            }}</span>
                            <vs-input
                                class="w-full"
                                v-model="cvData.desired_salary"
                                v-mask="'##########'"
                                :placeholder="$t('desired_salary')"
                            ></vs-input>
                        </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="lg:pr-4">
                        <div>
                            <span class="bold mb-2">{{
                                $t("work_schedule")
                            }}</span>
                            <multiselect
                                v-model="selectedSchedule"
                                :options="schedules"
                                :searchable="false"
                                open-direction="top"
                                :close-on-select="true"
                                label="text"
                                :placeholder="$t('select_filter')"
                                :show-labels="false"
                                @input="setSchedule()"
                            >
                            </multiselect>
                            <!-- <v-select class="w-full" label="text" :options="schedules" v-model="selectedSchedule" @input="setSchedule()"></v-select> -->
                        </div>
                    </vs-col>
                </vs-row>
            </div>
            <div class="mb-5 flex">
                <vs-checkbox
                    color="rgb(115,103,240)"
                    v-model="cvData.has_experience"
                >
                    <span class="subtitle-text">
                        {{ $t("job_expirience_true") }}
                    </span>
                </vs-checkbox>
            </div>
            <div v-if="cvData.has_experience" class="mb-4">
                <vs-row
                    class="mb-5"
                    vs-w="12"
                    v-for="(item, index) in cvData.job_experience"
                    :key="index"
                >
                    <vs-col vs-sm="12" vs-lg="6" class="lg:pr-4 mb-5">
                        <div>
                            <span class="bold mb-2">{{ $t("position") }}</span>
                            <vs-input
                                class="w-full"
                                :placeholder="$t('position')"
                                v-model="item.position"
                            ></vs-input>
                        </div>
                    </vs-col>
                    <vs-col vs-sm="12" vs-lg="6" class="mb-5">
                        <div>
                            <span class="bold mb-2">{{
                                $t("company_name")
                            }}</span>
                            <vs-input
                                class="w-full"
                                :placeholder="$t('company_name')"
                                v-model="item.company_name"
                            ></vs-input>
                        </div>
                    </vs-col>
                    <vs-col vs-sm="12" vs-lg="6" class="lg:pr-4 mb-5">
                        <div>
                            <span class="bold mb-2">{{
                                $t("start_date")
                            }}</span>
                            <flat-pickr
                                v-model="item.begin"
                                :config="config"
                                class="w-full"
                                v-validate="'required'"
                                name="payment_date"
                                :placeholder="$t('select_date')"
                            />
                            <span class="text-danger text-sm" v-show="item.begin == '' || item.begin == null">
                                {{ $t('validation_required') }}*
                            </span>
                        </div>
                    </vs-col>
                    <vs-col vs-sm="12" vs-lg="6" class="mb-5">
                        <div>
                            <span class="bold mb-2">{{ $t("end_date") }}</span>
                            <flat-pickr
                                v-model="item.end"
                                :config="config"
                                class="w-full"
                                :placeholder="$t('select_date')"
                            />
                        </div>
                    </vs-col>
                    <vs-col class="w-full">
                        <div>
                            <span class="bold mb-2">{{
                                $t("responsibility")
                            }}</span>
                            <vs-textarea
                                :placeholder="$t('responsibility')"
                                v-model="item.responsibility"
                            />
                        </div>
                    </vs-col>
                    <vs-button
                        class="-mt-2"
                        icon="delete"
                        color="danger"
                        @click="deleteJobExp(item)"
                        >{{ $t("remove") }}</vs-button
                    >
                </vs-row>
            </div>
            <vs-button
                v-if="cvData.has_experience"
                class="mb-10"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                @click="addJobExp()"
            >
                {{ $t("add_work_place") }}
            </vs-button>
            <span v-if="cvData.has_experience && cvData.job_experience.length <= 0" class="text-danger w-full text-sm">
                {{ $t("names_for_validate.valid_work_place") }}*
            </span>
            <div class="mb-3">
                <div class="mb-3 lg:mb-5">
                    <span class="subtitle-text">{{
                        $t("knowleges_adn_skills")
                    }}</span>
                </div>
                <vs-row>
                    <vs-col class="w-full">
                        <div class="lg:pr-4">
                            <span class="bold mb-2">{{
                                $t("pro_skills")
                            }}</span>
                            <vs-textarea
                                :placeholder="$t('pro_skills')"
                                v-model="cvData.pro_skills"
                            />
                        </div>
                    </vs-col>
                    <vs-col class="w-full">
                        <div class="lg:pr-4">
                            <span class="bold mb-2">{{
                                $t("other_skills")
                            }}</span>
                            <vs-textarea
                                :placeholder="$t('other_skills')"
                                v-model="cvData.other_skills"
                            />
                        </div>
                    </vs-col>
                </vs-row>
            </div>
            <div class="mb-5">
                <div class="mb-3 lg:mb-5">
                    <span class="subtitle-text">{{
                        $t("additional_courses")
                    }}</span>
                </div>
                <vs-row v-for="(item, index) in cvData.courses" :key="index">
                    <vs-col>
                        <vs-row>
                            <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="mb-3 lg:mb-0 lg:pr-2">
                                <div>
                                    <span>{{ $t("course_name") }}</span>
                                    <vs-input
                                        class="w-full"
                                        v-model="item.name"
                                        :placeholder="$t('course_name')"
                                    ></vs-input>
                                </div>
                            </vs-col>
                            <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="lg:pr-2">
                                <div>
                                    <span>{{ $t("place_of_passage") }}</span>
                                    <vs-input
                                        class="w-full"
                                        :placeholder="$t('place_of_passage')"
                                        v-model="item.place"
                                    ></vs-input>
                                </div>
                            </vs-col>
                            <vs-col
                                vs-lg="4"
                                vs-sm="4"
                                vs-xs="12"
                                class="button"
                            >
                                <div class="vx-row mb-2">
                                    <div class="vx-col">
                                        <label
                                            :id="setId('div', index)"
                                            :for="setId('input', index)"
                                            class="vs-con-loading__container files_input_button vs-component vs-button vs-button-primary vs-button-filled includeIcon"
                                        >
                                            <i
                                                class="vs-icon notranslate icon-scale vs-button--icon feather icon-upload null"
                                                style="
                                                    order: 0;
                                                    margin-right: 5px;
                                                    margin-left: 0px;
                                                "
                                            ></i>
                                            <span
                                                class="vs-button-text vs-button--text"
                                                >{{ $t("upload_file") }}</span
                                            >
                                        </label>
                                    </div>
                                </div>
                                <input
                                    type="file"
                                    :id="setId('input', index)"
                                    class="files_input"
                                    ref="files"
                                    v-on:change="handleFileUpload(index)"
                                />

                                <vs-button
                                    class="-mt-2 ml-2"
                                    icon="delete"
                                    color="danger"
                                    @click="deleteCourse(item.uid ? item.uid : item.id, index)"
                                ></vs-button>
                                <div class="pb-2" style="margin-left: 10px" v-if="item.certificate">
                                    <a
                                        @click="openLink(item.certificate.path)"
                                        target="_window"
                                        download
                                        class="archive_link vs-component"
                                        style="cursor: pointer;">
                                        {{$t('download_file')}}
                                    </a>
                                </div>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </div>
            <vs-button
                class="mb-10"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                @click="addCourse()"
            >
                {{ $t("add_course") }}
            </vs-button>
            <div class="submit-buttons">
                <vs-button
                    class="mr-2"
                    type="border"
                    @click="showPreViewPopup()"
                    >{{ $t("preview") }}</vs-button
                >
                <vs-button
                    :disabled="!validateForm"
                    ref="loadableButton"
                    id="button-with-loading"
                    class="vs-con-loading__container"
                    @click="createCV()"
                >
                    {{ $t("save") }}</vs-button
                >
                <vs-button
                    :disabled="!validateForm"
                    ref="loadableButton"
                    id="button-with-loading"
                    class="vs-con-loading__container ml-2"
                    icon="delete"
                    color="danger"
                    @click="deleteCVHandler(cvData)"
                >
                    {{ $t("delete") }}</vs-button
                >

            </div>
        </vx-card>
        <pre-view-popup v-bind="PreViewPopup" :userName="userName" @close="closePreViewPopup" />
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import PreViewPopup from "./Popups/PreViewPopup";
import ProfileInfo from "./QuestionnaireCreate/ProfileInfo";
import { mapActions, mapGetters } from "vuex";
import "cropperjs/dist/cropper.css";
import { Russian } from "flatpickr/dist/l10n/ru";
import { Kazakh } from "flatpickr/dist/l10n/kz";
import Cropper from "cropperjs";
export default {
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {
            LocalUserData: {educations: [{}, {}]},
            jobExpirience: false,
            files_data: [],
            selectedSchedule: null,
            selectedStudyPlan: null,
            croperModal: false,

            dataUrl: null,
            cropper: null,
            file: true,
            schedules: [],
            study_plans: [],
            config: {
                altFormat: "M j, Y",
                altInput: true,
                // locale: this.$i18n.locale === "kk" ? "kz" : this.$i18n.locale,
            },
            PreViewPopup: {
                active: false,
                data: null,
            },
            cropperOptions: {
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: true,
                zoomable: true,
                minCropBoxWidth: 150,
                minCropBoxHeight: 150,
            },

            cvData: {
                job_experience: [],
                courses: [],
                desired_position: "",
                desired_salary: null,
                schedule_v: "",
                has_experience: false,
                pro_skills: "",
                other_skills: "",
                avatar: null,
                cv_avatar: null,
                study_plan: null,
                uploadSettings: null,
                student: {
                    age: null,
                    address: "",
                    citizenship: "",
                    nationality: "",
                    marital_status: "",
                },
                studyPlan:null
            },
        };
    },
    components: {
        PreViewPopup,
        ProfileInfo,
    },
    watch: {
        croperModal() {
            this.hiddenHandler();
        },
    },
    computed: {
        ...mapGetters({
            user: "user/getUser",
            sudentSVs: "employment/getSudentSVs",
            VacancyDetail: "employment/getVacancyDetail",
        }),
        validateForm() {
            if(this.cvData.has_experience == true) {
                return (
                    !this.errors.any() &&
                    this.cvData.desired_position !== null &&
                    this.cvData.desired_salary !== null &&
                    this.cvData.schedule_v !== "" &&
                    this.cvData.pro_skills !== "" &&
                    this.cvData.job_experience.length
                );
            } else {
                return (
                    !this.errors.any() &&
                    this.cvData.desired_position !== null &&
                    this.cvData.desired_salary !== null &&
                    this.cvData.schedule_v !== "" &&
                    this.cvData.pro_skills !== ""
                );
            }
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if (this.$i18n.locale === "en") {
                // Если имя на англ пустое, используем рус имя
                if (this.user.first_name_en)
                    return `${ this.user.last_name_en } ${ this.user.first_name_en }`;
                else
                    return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`;
            } else
                return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`;
        },
    },
    async created() {
        this.cvData.avatar = this.user.avatar;
        let study_plans = [];
        await this.getStudyPlans().then(function(res){
            for(var i = 0; i < res.length; i++){
                res[i].key = i.toString();
                res[i].text = "Уч. план "+res[i].number;
            }
            study_plans = res;

        }, function(err){});

        //this.filter.studyPlan = this.study_plans[0];
        this.study_plans = study_plans;
        if(this.study_plans.length == 1){
            this.studyPlan = study_plans[0];
        }

    },
    methods: {
        ...mapActions({
            updateStudentCV: "employment/updateStudentCV",
            getstudentCVs: "employment/getstudentCVs",
            getDetailStudentCV: "employment/getDetailStudentCV",
            createStudentCV: "employment/createStudentCV",
            getUserProfile: "employment/getUserProfile",
            deleteStudentCV: "employment/deleteStudentCV",
            getSchedules: "employment/getSchedules",
            getStudyPlans: "employment/getStudyPlans"
        }),
        openLink(link){
            window.open(link,'_blank')
        },
        hiddenHandler() {
            this.dataUrl = null;
            this.cropper = null;
            this.file = false;
            setTimeout(() => {
                this.file = true;
            }, 300);
        },
        createCropper() {
            this.cropper = new Cropper(
                this.$refs.avatarImg,
                this.cropperOptions
            );
        },

        async uploadImage() {
            this.$vs.loading({
                container: ".files_input_button",
                scale: 0.45,
            });
            this.cropper.getCroppedCanvas().toBlob(async (avatar) => {
                let formData = new FormData();



                formData.append(
                    "path",
                    avatar,
                    `avatar${ Math.random(999999) }.png` // Нужно убрать Math.random и сделать нормальную генерацию имен для аватарок
                );
                formData.append("is_image", true);

                // Если formData не пустая то продолжаем отправку
                if (formData.has("path")) {
                    try {
                        // Загружаем файлы на сервер
                        const { data } = await this.$http.post(
                            "common/upload/",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );

                        // Пушим ответ с сервера в переменную, создаем нужные ключи для редактирования имени и описания файла

                        this.cvData.cv_avatar = data[0].uid;
                        this.cvData.avatar = data[0].path;

                    } catch (error) {
                        this.$vs.notify({
                            text: this.$t("error"),
                            color: "danger",
                        });
                    } finally {
                        this.croperModal = false;
                        this.hiddenHandler();
                        this.$vs.loading.close(
                            ".files_input_button > .con-vs-loading"
                        );
                        this.$vs.notify({
                            text: this.$t("data_saved"),
                            color: "success",
                        });
                    }
                }
            });
        },
        async handleFileUploadd() {
            // Получаем файлы от поля загрузки
            const file = this.$refs.avatarUpload.files[0];
            if (
                this.uploadSettings.max_file_size &&
                file.size / 1024 / 1024 >= this.uploadSettings.max_file_size
            ) {
                this.$vs.notify({
                    text: `Файл ${ file.name } превышает ${ this.uploadSettings.max_file_size } мегабайт!`,
                    color: "warning",
                });
            } else {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.dataUrl = e.target.result;
                };

                reader.readAsDataURL(file);

                this.croperModal = true;
            }
        },
        setSchedule() {
            if (this.selectedSchedule) {
                this.cvData.schedule_v = this.selectedSchedule.uid;
            }
        },
        setStudyPlan() {
            if (this.selectedStudyPlan) {
                this.cvData.study_plan = this.selectedStudyPlan.uid;
            }
        },
        goBack() {
            this.$router.push({
                name: "my_cv_s",
            });
        },
        addJobExp() {
            let obj = {
                id: Math.random(99999),
                position: "",
                company_name: "",
                begin: "",
                end: "",
                responsibility: "",
            };
            this.cvData.job_experience.push(obj);
        },
        deleteJobExp(item) {
            if(item.id) {
                this.cvData.job_experience = this.cvData.job_experience.filter(
                    (el) => el.id !== item.id
                );
            } else {
                this.cvData.job_experience = this.cvData.job_experience.filter(
                    (el) => el.uid !== item.uid
                );
            }

        },
        addCourse() {
            let obj = {
                id: Math.random(99999),
                name: "",
                code: "001",
                place: "",
                certificate: null,
            };
            this.cvData.courses.push(obj);

            // console.log("cvData", this.cvData.courses)
        },
        deleteCourse(id, index) {
            this.cvData.courses = this.cvData.courses.filter(function(el) {
                return !(el.uid === id || el.id === id);
            });

            this.files_data.splice(index, 1);
        },
        async setLoacalDataForEdit() {
            this.$vs.loading({
                container: "#cv-div-loading",
                scale: 0.6,
            });
            const data = await this.getDetailStudentCV(this.$route.params.uid);
            if (data) {
                this.cvData = data;
                this.cvData.avatar =
                    data.cv_avatar == null ? this.user.avatar : data.cv_avatar.path;
                // if (this.cvData.schedule === "1") {
                //     this.selectedSchedule = this.schedules[0];
                // } else if (this.cvData.schedule === "2") {
                //     this.selectedSchedule = this.schedules[1];
                // }
                for(var i = 0; i < this.schedules.length; i++){
                    if(this.schedules[i].uid === this.cvData.schedule_v){
                        this.selectedSchedule = this.schedules[i];
                        break;
                    }
                }

            }
            this.$vs.loading.close("#cv-div-loading > .con-vs-loading");
        },
        setId(type, index) {
            if (type === "input") {
                let str = `input_${ index }`;
                return str;
            } else if (type === "div") {
                let str = `div_loading_${ index }`;
                return str;
            }
        },
        showPreViewPopup() {

            if(this.cvData.student.age === null) {

                this.cvData.student = this.LocalUserData

                this.cvData.student.last_name =   this.user.lastName
                this.cvData.student.first_name = this.user.firstName
                this.cvData.student.middle_name = this.user.middleName
            }
            if(this.LocalUserData.educations.lenght > 0) this.cvData.student.education = this.LocalUserData.educations[0].institute
            this.cvData.student.birth_place = this.LocalUserData.birth_place
            this.PreViewPopup.data = this.cvData;
            this.PreViewPopup.active = true;
        },
        closePreViewPopup() {
            this.PreViewPopup.active = false;
        },
        async userPrifile() {
            const data = await this.getUserProfile(this.user.profileId);
            this.LocalUserData = data;
        },
        async handleFileUpload(index) {
            // Получаем файлы от поля загрузки
            const files = this.$refs.files[index].files;
            let formData = new FormData();
            for (var i = 0; i < files.length; i++) {
                // Заполняем formData перед загрузкой файлов
                formData.append("path", files[i]);
            }

            // Если formData не пустая то продолжаем отправку
            if (formData.has("path")) {
                try {
                    this.$vs.loading({
                        background: "primary",
                        color: "#fff",
                        container: `#div_loading_${ index }`,
                        scale: 0.45,
                    });

                    // Загружаем файлы на сервер
                    const { data } = await this.$http.post(
                        "common/upload/",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    );

                    // Пушим ответ с сервера в переменную, создаем нужные ключи для редактирования имени и описания файла
                    data.forEach((file) => {
                        for (let i = 0; i <= index; i++){
                            if (i === index){
                                this.files_data[i] = {
                                    uid: file.uid,
                                    formName: file.name,
                                    name: "",
                                    description: "",
                                    response: file,
                                };
                            }
                            else {
                                this.files_data[i] = null
                            }
                        }
                    });

                    this.cvData.courses[index].certificate = this.files_data[
                        index
                    ].uid;

                } catch (error) {
                    this.$vs.notify({ text: error, color: "danger" });
                } finally {
                    this.$vs.loading.close(
                        `#div_loading_${ index } > .con-vs-loading`
                    );
                }
            }
        },
        async createCV() {
            try{
                this.$vs.loading({
                    container: "#button-with-loading",
                    scale: 0.45,
                });
                if(this.cvData.cv_avatar && this.cvData.cv_avatar.path){
                    this.cvData.cv_avatar = this.cvData.cv_avatar.uid
                }

                if (this.$route.params.uid) {
                    this.cvData.courses = this.cvData.courses.map((el)=>{
                        let clone_certificate;
                        if (typeof el.certificate === 'object' && el.certificate !== null){
                            clone_certificate = el.certificate.uid
                        }
                        else{
                            clone_certificate = el.certificate
                        }
                        return {...el, certificate: clone_certificate}
                    })

                    delete this.cvData.student;

                    await this.updateStudentCV(this.cvData);
                    await this.init();
                    this.$vs.notify({
                        title: this.$t("cv"),
                        text: this.$t("cv_updated"),
                        color: "rgb(70,201,58)",
                    });
                    this.$vs.loading.close(
                        "#button-with-loading > .con-vs-loading"
                    );
                } else {
                    delete this.cvData.student;

                    // console.log(this.cvData);
                    await this.createStudentCV(this.cvData);
                    await this.init();
                    this.$vs.notify({
                        title: this.$t("cv"),
                        text: this.$t("cv_created"),
                        color: "rgb(70,201,58)",
                    });
                    this.goBack();

                }
            } catch(e){
                this.$vs.notify({ text: this.$t('error_validate'), color: "danger" });
            }
            finally{
                this.$vs.loading.close(
                    "#button-with-loading > .con-vs-loading"
                );
            }
        },
        async deleteCVHandler(item) {
            this.$vs.loading({
                container: "#cv-div-loading",
                scale: 0.6,
            });
            await this.deleteStudentCV(item.uid);
            this.$vs.notify({
                title: this.$t("cv"),
                text: this.$t("cv_removed"),
                color: "rgb(234,84,85)",
            });
            await this.getstudentCVs();
            this.$vs.loading.close("#cv-div-loading > .con-vs-loading");
            this.goBack();
        },
        async init() {

            let schedules = [];
            await this.getSchedules().then(function(res){
                for(var i = 0; i < res.length; i++){
                    res[i].key = i.toString();
                    res[i].text = res[i].name_ru;
                }
                schedules = res;

            }, function(err){});

            this.schedules = schedules;

            this.userPrifile();
            if (this.$route.params.uid) {
                await this.setLoacalDataForEdit();
            }
            this.uploadSettings = (
                await this.$http.get(`/common/settings/`)
            ).data[0];
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.files_input_button {
    // max-width: 220px;
    max-height: 2.7rem;
    position: relative;
    overflow: hidden;
    display: -webkit-inline-box;
    .con-vs-loading {
        position: absolute;
    }
}
.files_input {
    display: none;
}
.vals_list{
    .item{
        &:not(:last-child){
            margin-bottom: 8px;
        }
    }
}
@media only screen and (min-width: 993px) {
    .vals_list{
        .label{
            min-width: 250px;
        }
    }
}
.avatar_cropper {
    position: relative;
    img {
        max-width: 100%;
        height: 100%;
        max-height: 400px;
    }
}
@media screen and (max-height: 580px) {
    .avatar_cropper {
        img {
            max-height: 300px;
        }
    }
}

.avatarImg img {
    object-fit: cover;
}
</style>

<style scoped>
.number-input {
    border-radius: 5px;
    box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 15%);
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0.7rem !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
.button-uploaded {
    color: #2dcd7a;
}
.center {
    justify-content: space-between;
    align-items: center;
}
.submit-buttons {
    display: flex;
    justify-content: flex-end;
}
.button {
    align-items: center;
    display: flex;
    padding-top: 20px;
}
.bold {
    font-weight: bold;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.infos-column {
    display: flex;
    flex-direction: column;
}
.name-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.name {
    font-size: large;
    font-weight: bold;
}
.ok-button {
    border-radius: 30px;
}
.welcone-text {
    align-items: center;
    justify-content: space-between;
    font-size: large;
    font-weight: 600;
    border-radius: 20px 20px 20px 0px;
    color: white;
    background-color: #545da7;
}
.subtitle-text {
    font-weight: 500;
    color: #545da7;
}
.back-div {
    display: flex;
    align-items: center;
}
@media only screen and (min-width: 801px) {
    .subtitle-text {
        font-size: large;
    }
}
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}

</style>
